import { BuyableVehicle } from '~/app/tracking/feld-m-types';
import { StockCarNewFragment, StockCarUsedFragment } from '~/graphql/__generated__/graphql';

export const mapTrackingData = (
	similarCar: StockCarNewFragment | StockCarUsedFragment,
	totalPrice: number | undefined,
): BuyableVehicle => {
	const productID = similarCar.stockCar.model?.id.code || '';
	const productName = similarCar.stockCar.model?.name || '';
	const subCategory1 = similarCar.stockCar.carline?.id || '';
	const productType = similarCar.stockCar.cartypeText === 'N' ? 'new car' : 'used car';
	const totalPriceString = totalPrice ? totalPrice.toString() : '';

	return {
		buyableVehicle: {
			productInfo: {
				productID,
				productName,
			},
			category: {
				subCategory1,
				productType,
			},
			price: {
				totalPrice: totalPriceString,
			},
		},
	};
};
